import { MisleadLevel } from '../../../general/model';

const levels: MisleadLevel[] = [];

// Ранее мислиды были захардкожены, теперь получаем их с бэка.
// Чтобы с минимальными изменениями заменить прежние обращения к списку мислидов, создаем этот синглтон.
// Мислиды загружаются в процессе инициализации приложения,
// еще до того, как рендерится приложение и запускаются другие лисенеры.
// Поэтому в компонентах, лисенерах, кейсах редюсера можно читать данные из синглтона.
// Во время создания initialState в редюсерах мислиды, возможно, еще не загружены.
// Если есть необходимость избавиться от синглтона и хранить мислиды в стейте,
// то надо будет обеспечить доступ к стейту во всех местах приложения, где идет обращение к этим мислидам.
// А это не всегда просто сделать.

export const misleadSingleton = {
  getAll(): MisleadLevel[] {
    return [...levels];
  },
  getUnset(): MisleadLevel | undefined {
    return levels.find((level) => level.is_unset);
  },
  findById(value: MisleadLevel['id']): MisleadLevel | undefined {
    return levels.find((level) => level.id === value);
  },
  setAll(list: MisleadLevel[]): void {
    levels.splice(0, levels.length, ...list);
  },
};
